import { useAtomValue } from 'infrastructure/state/jotai.wrapper'
import { sourceTreeAtom, sourceTreeIdMap } from './atoms'
import React from 'react'
import { useFilteredSourceNodes } from './hooks'
import { Table } from 'shared/ui/Table/Table'
import {
  cellForType,
  getNodeRowDataAsString,
  nodePathCell,
  openKiddomCell,
  titleCell,
} from './tableColumns'
import { NodeType } from 'shared/types/ingestion'

export function SourceTree() {
  const tree = useAtomValue(sourceTreeAtom)

  const columns = useTableColumns()
  const nodes = useFilteredSourceNodes()

  if (!tree) return null

  return (
    <>
      <Table
        title="Source Tree Activity Nodes"
        columns={columns}
        items={nodes}
        canExport={true}
      />
    </>
  )
}

function useTableColumns() {
  const idMap = useAtomValue(sourceTreeIdMap)
  return [
    {
      title: 'Title',
      rowContent: titleCell(idMap),
      rowString: getNodeRowDataAsString({
        destIdMap: idMap,
        dataType: 'title',
      }),
    },
    {
      title: 'Node Path',
      rowContent: nodePathCell(idMap),
      rowString: getNodeRowDataAsString({
        destIdMap: idMap,
        dataType: 'path',
      }),
    },
    {
      title: 'Unit',
      rowContent: cellForType(NodeType.Unit, idMap),
      rowString: getNodeRowDataAsString({
        destIdMap: idMap,
        dataType: 'unit',
      }),
    },
    {
      title: 'Lesson Plan',
      rowContent: cellForType(NodeType.LessonPlan, idMap),
      rowString: getNodeRowDataAsString({
        destIdMap: idMap,
        dataType: 'lesson',
      }),
    },
    {
      title: 'Kiddom',
      rowContent: openKiddomCell(idMap),
      rowString: getNodeRowDataAsString({
        destIdMap: idMap,
        dataType: 'url',
      }),
    },
  ]
}
